import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Migration guidance is documented in the speech-to-text README.
/**
 * @deprecated See the {@link https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/insights-ai-platform/ai-audio/src/speech-to-text/README.md speech-to-text README} for information about the new API.
 */
export const VoiceRejectButton = ({ onClick }: { onClick: () => void }): React.JSX.Element => {
	return (
		<IconButton
			shape="circle"
			isTooltipDisabled={false}
			icon={(iconProps) => <CrossIcon {...iconProps} label={''} />}
			appearance="subtle"
			onClick={onClick}
			label="Reject"
		/>
	);
};
